/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./withdrawdelivers.vue?vue&type=template&id=5c888b6e&scoped=true"
import script from "./withdrawdelivers.vue?vue&type=script&lang=js"
export * from "./withdrawdelivers.vue?vue&type=script&lang=js"
import style0 from "./withdrawdelivers.vue?vue&type=style&index=0&id=5c888b6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c888b6e",
  null
  
)

export default component.exports